import { THEME } from '../../../../constants';
import {
  COMMON_CHART_FONT_STYLES,
  getChartBaseColors,
  getChartFontColor,
  getChartGridColor,
  getTrendColor,
  getChartDataLabelColor,
} from '../../../../utils/chart';
import createInfoboxMarkup from '../../../infobox/createInfoboxMarkup';

const getAreaConfig = (data, theme = THEME.DARK, title, dataKey, isShowTrend) => {
  const fontColor = getChartFontColor(theme);
  const gridColor = getChartGridColor(theme);
  const BASE_COLORS = getChartBaseColors(theme);

  const labels = data.map((domainEntree) => domainEntree.label || domainEntree.domain);

  return {
    options: {
      title: {
        text: title,
        style: {
          color: fontColor,
          ...COMMON_CHART_FONT_STYLES,
        },
      },
      chart: {
        height: 350,
        type: 'area',
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      colors: [BASE_COLORS.BLUE, BASE_COLORS.RED],
      dataLabels: {
        enabled: false,
      },
      fill: {
        opacity: 0.9,
        type: 'solid',
      },
      stroke: {
        show: false,
      },
      xaxis: {
        categories: labels,
        labels: {
          rotate: -45,
          rotateAlways: true,
          minHeight: 100,
          style: {
            colors: getXAxisLabelColors(data, theme),
            ...COMMON_CHART_FONT_STYLES,
          },
          formatter: function (value) {
            const limit = 19;
            return value && value.length > limit ? value.substring(0, limit - 3) + '...' : value;
          },
        },
        axisTicks: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
      },
      yaxis: {
        labels: {
          minWidth: 60,
          style: {
            colors: fontColor,
            ...COMMON_CHART_FONT_STYLES,
          },
        },
      },
      legend: {
        position: 'top',
        fontWeight: 600,
        labels: {
          colors: fontColor,
        },
      },
      grid: {
        show: true,
        borderColor: gridColor,
      },
      tooltip: {
        fillSeriesColor: false,
        theme: false,
        style: {
          dropShadow: {
            enabled: false,
          },
        },
        custom: function ({ dataPointIndex }) {
          const domainEntree = data[dataPointIndex];
          const label = domainEntree.label || domainEntree.domain;

          const tooltipTitle = label || domainEntree.domain;
          const tooltipSubtitle = domainEntree.companyName ? domainEntree.domain : '';

          const records = [];

          const score = domainEntree?.[dataKey].score;
          const trend = domainEntree?.[dataKey].trend;

          records.push({
            name: 'Score',
            value: score,
            color: BASE_COLORS.BLUE,
          });

          isShowTrend &&
            records.push({
              name: 'Trend',
              value: trend,
              color: getTrendColor({ trend, score, theme }),
            });

          return createInfoboxMarkup({
            title: tooltipTitle,
            subTitle: tooltipSubtitle,
            records,
          });
        },
      },
    },
  };
};

function getXAxisLabelColors(data, theme) {
  return data.map((domainEntree) =>
    getChartDataLabelColor({ inFocus: domainEntree.inFocus, myCompany: domainEntree.myCompany, theme }),
  );
}

export default getAreaConfig;
